import * as actions from './actionTypes';
import { setLoading, setMessage } from './general';
import axios from '../../config/axiosInstance';

export const createSchedule = schedule => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post('/workingDay', schedule)
    .then((_) => {
      dispatch(setLoading(false));
      dispatch(setMessage('Escala cadastrada com sucesso.'));
      return Promise.resolve();
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const fetchSchedulesSuccess = schedules => ({
  type: actions.FETCH_SCHEDULES_SUCCESS,
  schedules,
});

export const fetchSchedules = () => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .get('/workingDay')
    .then((response) => {
      dispatch(fetchSchedulesSuccess(response.data));
      dispatch(setLoading(false));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const deleteScheduleSuccess = id => ({
  type: actions.DELETE_SCHEDULE_SUCCESS,
  id,
});

export const deleteSchedule = id => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .delete(`/workingDay/${id}`)
    .then(() => {
      dispatch(deleteScheduleSuccess(id));
      dispatch(setLoading(false));
      dispatch(setMessage('Escala excluida com sucesso.'));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const updateScheduleNameSuccess = (id, name, horaryClosing) => ({
  type: actions.UPDATE_SCHEDULE_NAME_SUCCESS,
  id,
  name,
  horaryClosing,
});

export const updateScheduleName = (data) => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .put('/workingDay/', {
      data
    })
    .then((_) => {
      dispatch(updateScheduleNameSuccess(data));
      dispatch(setLoading(false));
      dispatch(setMessage('Escala atualizada com sucesso'));
    })
    .catch((_) => {
      dispatch(setLoading(false));
      dispatch(setMessage('A escala não pode ser atualizada'));
    });
};
